// 提取obj里面的
// lodash.pick的代替品
export function pick(obj, keys, defaultValue) {
  // eslint-disable-line
  return keys.reduce(function(result, key) {
    if (obj[key]) {
      result[key] = obj[key]
    }
    return result
  }, {})
}

// lodash.omit的代替品
export function omit(obj, keys) {
  var result = {},
    key

  for (key in obj) {
    if (keys.indexOf(key) == -1) result[key] = obj[key]
  }

  return result
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/objOperation.js